module.exports = __webpack_public_path__ + "img/kenchadze_logo.1bc009b8.svg";